import CircleQuestionMarkSvg from '@assets/images/svg/circle-question-mark.svg';
import React from 'react';
import { View } from 'react-native';

export function CircleQuestionMarkIcon({ size = 24, color = '#333333' }: { size?: number; color?: string }) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <CircleQuestionMarkSvg width={size} height={size} color={color} />
        </View>
    );
}



